import { setupInterceptorsTo } from './axiosInterceptors';
import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '',
  headers: {
    'Content-Type': 'application/json',
  },
});

export default setupInterceptorsTo(instance);
